(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.CropResidueRemovedController = (function(superClass) {
    extend(CropResidueRemovedController, superClass);

    function CropResidueRemovedController(scope, transitions, modalInstance, service) {
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.service = service;
      this.getYieldUnit = bind(this.getYieldUnit, this);
      CropResidueRemovedController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);
      this.scope.service = this.service;
      this.scope.getYieldUnit = this.getYieldUnit;
      this.previousValues = {
        current_crop_residue_removed: this.service.fpcResult.data.current_crop_residue_removed,
        previous_crop_residue_removed: this.service.fpcResult.data.previous_crop_residue_removed,
        selected_previous_crop: this.service.fpcResult.data.selected_previous_crop,
        previous_crop_yield: this.service.fpcResult.data.previous_crop_yield
      };
    }

    CropResidueRemovedController.prototype.getYieldUnit = function() {
      var units;
      if (!this.service.fpcResult.data.selected_previous_crop) {
        return null;
      }
      units = this.service.allCrops.find((function(_this) {
        return function(crop) {
          return crop.name === _this.service.fpcResult.data.selected_previous_crop;
        };
      })(this)).yield_unit;
      return {
        'short_ton / acre': 'ton/ac',
        'bushel / acre': 'bu/ac',
        'lb / acre': 'lb/ac',
        'cwt / acre': 'cwt/ac'
      }[units];
    };

    CropResidueRemovedController.prototype.save = function() {
      this.service.save(this.service.state.params.id);
      return this.modalInstance.dismiss('cancel');
    };

    CropResidueRemovedController.prototype.cancel = function() {
      this.service.fpcResult.data.current_crop_residue_removed = this.previousValues.current_crop_residue_removed;
      this.service.fpcResult.data.previous_crop_residue_removed = this.previousValues.previous_crop_residue_removed;
      this.service.fpcResult.data.selected_previous_crop = this.previousValues.selected_previous_crop;
      this.service.fpcResult.data.previous_crop_yield = this.previousValues.previous_crop_yield;
      return this.modalInstance.dismiss('cancel');
    };

    return CropResidueRemovedController;

  })(DialogController);

}).call(this);
